import React, { useState, useEffect, useRef } from "react";
import scrollTo from 'gatsby-plugin-smoothscroll';
import InView from "react-intersection-observer";
import HeaderAnim from "../utils/animations/textRevealAnimation";
import { motion } from 'framer-motion';

export default function DesignSprints(props) {
  const { title, header, subHeader, items } = props.data;
  const [isVisible, setIsVisible] = useState(false);
  const [elementTop, setElementTop] = useState(0);
  const [clientHeight, setClientHeight] = useState(0);
  const ref = useRef();
  //0.65, 0.60, 0.55, 0.50, 0.45, 0.40,
  const triggerPoints = [0.70, 0.65, 0.6, 0.55, 0.45, 0.35, 0.30, 0.25, 0.10, 0.05];
  const triggers = [[0.90, 0.85], [0.87, 0.82], [0.84, 0.79], [0.81, 0.76], [0.78, 0.73], [0.75, 0.7]];
  useEffect(() => {
    if (!ref.current) return;
    //console.log('banner top: ', ref.current.offsetTop);
    const setValues = () => {
      setElementTop(ref.current.offsetTop);
      setClientHeight(window.innerHeight);
    };

    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);
    return () => {
      window.removeEventListener('resize', setValues);
      document.removeEventListener('load', setValues);
    };
  }, [ref]);

  return (
    <div className="design-sprints-section section-gap" id={props.id}>
      <InView onChange={inView => setIsVisible(inView)} threshold={[0.15]}>
        <div className="container">
          <div className="design-sprints-content">
            <p className="theme-color-title">{isVisible && <HeaderAnim header={title} />}</p>
            <div className="left-border">
              <h3>{header} </h3>
              <p>{subHeader}</p>
            </div>
          </div>

          <ul className="design-sprints-list">
            {items.map((item, index) => {
              return (<li key={index} className="sprints-item">
                <div className="item-inner">
                  <div className="grid-icon white-bg">
                    <i>{item.icon}</i>
                  </div>
                  <p>{item.name}</p>
                </div>
              </li>);

            })}
            <li className="sprints-item sprints-item-action"><p>Request your free consultation</p><a onClick={() => scrollTo('#form-section')} className="button button-large button-black right-arrow" href="/contact/">Get Started</a></li>
          </ul>
        </div>
      </InView>
    </div>
  );
}
